import {InjectionToken} from "@angular/core";
import { IAppRestClient } from "./i-app-rest.client";

export const appRestClientInjectionToken: InjectionToken<IAppRestClient> = new InjectionToken<IAppRestClient>("digital-signage.developer-dashboard.dashboard-web.AppRestClient");
